module.exports = __webpack_public_path__ + "assets/img/integer-back.ee729641.png";